import { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { useNavigate } from "react-router-dom";

export const MasterTabs = (index: any) => {
  // state for active tab index
  const [activeIndex, setActiveIndex] = useState<number>(index.index);

  // state for navigation
  const navigate = useNavigate();

  // handle tab change
  const tabChange = (e: any) => {
    setActiveIndex(e.index);

    if (e.index === 0) {
      navigate("/master/services");
    }
    // else if (e.index === 1) {
    //   navigate("/master/booking-slots");
    // }
    else if (e.index === 1) {
      navigate("/master/crops");
    } else if (e.index === 2) {
      navigate("/master/service-item");
    } else if (e.index === 3) {
      navigate("/master/spray-for-problem");
    } else if (e.index === 4) {
      navigate("/master/soil-test-parameter");
    }
  };

  return (
    <>
      <TabView activeIndex={activeIndex} onTabChange={(e) => tabChange(e)}>
        <TabPanel header="Services"></TabPanel>
        {/* <TabPanel header="Booking Slots"></TabPanel> */}
        <TabPanel header="Crops"></TabPanel>
        <TabPanel header="Service Item"></TabPanel>
        <TabPanel header="Spray For Problem"></TabPanel>
        <TabPanel header="Soil Test Parameter"></TabPanel>
      </TabView>
    </>
  );
};
